import { render, staticRenderFns } from "./LargePNL.vue?vue&type=template&id=54cb39c4"
import script from "./LargePNL.vue?vue&type=script&lang=js"
export * from "./LargePNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports